import { getHighestUserRole, USER_ROLE_ATTRIBUTES, } from 'lib-shared-user-role';
import { getUserDisplayName } from 'utils/user/getUserDisplayName';
export const normalizeUser = (user) => {
    const { id, roles, email, phone_number, additional_emails, additional_phone_numbers, } = user;
    const highestRole = getHighestUserRole(roles !== null && roles !== void 0 ? roles : []);
    const userRole = USER_ROLE_ATTRIBUTES[highestRole];
    const normalizedName = getUserDisplayName(user);
    return {
        id: id,
        name: normalizedName,
        email: email !== null && email !== void 0 ? email : undefined,
        additionalEmails: additional_emails !== null && additional_emails !== void 0 ? additional_emails : [],
        phone: phone_number !== null && phone_number !== void 0 ? phone_number : undefined,
        additionalPhoneNumbers: additional_phone_numbers !== null && additional_phone_numbers !== void 0 ? additional_phone_numbers : [],
        roleAttributes: userRole,
    };
};
